import { apiClient } from "../clientApi";
import { useMutation } from "@tanstack/react-query";
import type { DefaultError } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

export interface PostSurveyRequest {
  orgId: number; // Organization ID
  courseName: string; // Course name (will be normalized to lowercase on backend)
  title: string; // Survey title
  description: string; // Survey description
  status?: string; // e.g. "draft" | "published" (optional)
  surveyJson?: Record<string, any>; // The actual survey JSON (optional but recommended)
}

export const usePostSurvey = ({
  onSuccess,
  onFail,
}: {
  onSuccess?: (data: any, variables: PostSurveyRequest, context: any) => void;
  onFail?: (error: any, variables: PostSurveyRequest, context: any) => void;
}) =>
  useMutation<any, DefaultError, any>({
    mutationFn: async (form) => {
      const { data } = await apiClient.post<any, AxiosResponse<any>, PostSurveyRequest>(`/surveys/survey`, form);

      return data as any;
    },
    onSuccess,
    onError: onFail,
  });
